import {LIST_MEMBER_REPORT, FETCH_MEMBER_REPORT, CLEAR_MEMBER_REPORT} from "./types";

const init = {
    isLoading: false,
    data: {},
    filter: {}
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_MEMBER_REPORT:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_MEMBER_REPORT:
            return {
                ...state,
                isLoading: false,
                data: payload.data,
            };
        case CLEAR_MEMBER_REPORT:
            return {
                ...init,
                isLoading: false,
            };
        default:
            return state;
    }
}